export default __webpack_public_path__ + "static/media/365-BizTool-Light-Logo.14f0deeb.png";